<template>
  <div class="menu-user">
    <div class="select-component">
      <select
        v-model="selectedGroupId"
        class="select"
        @change="(()=>{
          $store.commit('setSelectedUserId', '')
          getGroupUsers(selectedGroupId)})">
        <option
          disabled
          value="">選択してください</option>
        <option
          v-for="(group, index) in $store.state.groups.data"
          :key="index"
          :value="group.id">
          {{ group.name }}
        </option>
      </select>
    </div>
    <div class="users-component">
      <div
        v-for="(user,index) in users"
        :key="index">
        <User
          :user="user"
          class="user-component" />
      </div>
    </div>
  </div>
</template>

<script>
import User from '@/components/modules/DailyReport/MenuUserSelect'

export default {
  components: {
    User
  },
  computed: {
    /**
     * 人画面が選択されているときにユーザー一覧を表示するための変数
     * @returns {String} ユーザーID
     */
    users () { return this.$store.state.users.data.filter(user => user.isActive && user.isDisplay && this.$store.state.selectedUsers.some(u => u.id === user.id)) },
    /**
     * 現在選択されているグループのID
     * @param {Object} groupId 選択されたグループのID
     * @returns {String} グループID
     */
    selectedGroupId: {
      get () { return this.$store.state.selectedGroupId },
      set (groupId) { this.$store.commit('setSelectedGroupId', groupId) }
    }
  },
  mounted () {
    this.$nextTick(async () => {
      if (!this.$store.state.groups.data.find(group => group.id === localStorage.getItem('selectedGroupId'))) {
        localStorage.removeItem('selectedUserId')
        localStorage.removeItem('selectedGroupId')
        return
      }
      this.getGroupUsers(localStorage.getItem('selectedGroupId'))
    })
  },
  methods: {
    /**
     * 選択されたグループの情報から所属するユーザーを取得する
     * @param {String} groupId 選択されたグループのID
     */
    getGroupUsers (groupId) {
      this.selectedGroupId = groupId
      const group = this.$store.state.groups.data.find(group => group.id === this.selectedGroupId)
      if (group.isLoaded) {
        this.$store.commit('setSelectedUsers', group.children.users)
        return
      }
      this.getDiaries(group)
    },
    /**
     * 選択されたグループに所属するユーザーの日報を取得する
     * @param {String} groupId 選択されたグループのID
     */
    async getDiaries (group) {
      try {
        await this.$store.dispatch('getChildrenUsers', group)
        this.$store.commit('setSelectedUsers', group.children.users)
        await this.$store.dispatch('getUsers')
        this.$store.dispatch('getDiaries')
      }
      catch (error) {
        console.error(error)
      }
    }
  }
}

</script>

<style scoped>
.users-component {
  margin: 3px 0 0 0;
}
.user-component {
  margin: 0px 0 1px 3px;
}
.select-component{
  width: 100%;
  position: relative;
  display: inline-block;
}
.select-component::after {
  content: '';
  width: 6px;
  height: 6px;
  border: 0px;
  border-bottom: solid 2px #b4b3b3;
  border-right: solid 2px #b4b3b3;
  -ms-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  top: 50%;
  right: 10px;
  margin-top: -4px;
}
.select {
  -webkit-appearance: none;
  -moz-appearance: none;
  color: #666;
  font-size: 0.9em;
  appearance: none;
  width: 100%;
  height: 40px;
  background: transparent;
  position: relative;
  z-index: 1;
  padding: 0 40px 0 10px;
  border: 0px;
  border-bottom: 1px solid #e5e5e5;
}
select:focus {
  outline: none;
}
select::-ms-expand {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/DailyReport/MenuUser.vue